import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { InfoCard2 } from '../../../../widgets/components/UI/InfoCard2'
import { useIntl } from 'react-intl'
import { DisplayImage } from '../../../../widgets/components/General/DisplayImage'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Form, Formik } from 'formik'
import TextInput from '../../../../widgets/components/Input/TextInput'
import { ToolTipUIForModal } from '../../../../widgets/components/UI/ToolTipUIForModal'
import deleteicon from '../../../../../../media/stakeholders/ic-delete.svg'
import SelectHeaderDropDown from '../../../../widgets/components/Input/SelectInputDropDown'
import { InputWithPhone } from '../../../../widgets/components/Input/InputPhone'
import SelectSearchInput from '../../../../widgets/components/Input/SelectSearchInput'
import * as Yup from 'yup'
import {
  shareholdersCategoryOptions,
  shareholderSidebarFields,
  ShareholdersTypes,
} from '../../core/_constants'
import { FileUpload } from '../../../../widgets/components/FileUpload'
import { useAuth } from '../../../../auth'
import { toast } from 'react-toastify'
import { createShareholder, getSharholderDetails, updateShareholder } from '../../core/_requests'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getFileType, isOlderThan18, parseBoolean } from '../../../../../core/_util'
import { useGetAllDropdownData } from '../../../../../hooks/useGetAllDropdownData'
import Skeleton from 'react-loading-skeleton'
import { useFetchIndividualStakeholders } from '../../../../../hooks/useFetchIndividualStakeholders'
import TagifyInput from '../../../../shared-access/components/tagify-input'
import UserSearchTextInput from '../../../components/user-search-text-input'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../../hooks/gtmHelpers'
import parsePhoneNumberFromString, { isValidPhoneNumber } from 'libphonenumber-js'
import tooltipIcon from '../../../../../../_metronic/assets/images/svg/Vector.svg'
import { DeleteFileConfirmationModal } from '../../../components/delete-file-confirmation-modal'
import { allowedFileTypes } from '../../../../../core/_constants'
import brandingConfig from '../../../../../../config/brandingConfig'

export const AddIndividualStakeholderForm = ({
  setSelectedTab,
}: {
  setSelectedTab: Dispatch<SetStateAction<number>>
}) => {
  const { formatMessage } = useIntl()
  const [modalStatus, setModalStatus] = useState(false)
  const { companyId, currentUser } = useAuth()
  const navigate = useNavigate()
  const [shareholderDetailsLoading, setShareholderDetailsLoading] = useState(false)
  const [shareholderDetails, setShareholderDetails] = useState<any>(null)
  const [individualStakeholders, setIndividualStakeholders] = useState<any>(null)
  const [isLoading, setLoading] = useState(false)
  const [sidebar, setSidebar] = useState(1)
  const [imgName, setImgName] = useState('')
  const [clearFormDataShowModal, setClearFormDataShowModal] = useState(false)
  const [clearFormDataLoading, setClearFormDataLoading] = useState(false)
  const {
    countryOptions,
    stateOptions,
    setCountryId,
    govtIdOptions,
    phoneCodesOptions,
    stateDataLoading,
  } = useGetAllDropdownData(ShareholdersTypes.INDIVIDUAL)
  const [isNotInitialized, setIsNotInitiaized] = useState(true)
  const {
    resetFields,
    onClickBlurText,
    onClickFocusText,
    openUserDropdown,
    setOpenUserDropdown,
    dropdownDataLoading,
    dropDownData,
    setNewEntryButtonClicked,
    fetchIndividualStakeholders,
    stakeHoldersDataLoading,
    fieldClicked,
  } = useFetchIndividualStakeholders(setIndividualStakeholders, setImgName, setCountryId)
  const formikRef = useRef<any>(null)
  const [searchParams] = useSearchParams()
  const shareholderId = searchParams.get('shareholderId')
  const tab = searchParams.get('tab')
  const edit = searchParams.get('edit')?.toString() || ' '
  const fileRef = useRef<any>([])
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteFileId, setDeleteFileId] = useState<any>(null)
  const iscaptible = searchParams.get('iscaptible')

  useEffect(() => {
    if (!shareholderId || !companyId) return
    if (tab === ShareholdersTypes.INDIVIDUAL) setSelectedTab(1)
    const fetchShareholder = async () => {
      setSelectedTab(1)
      setShareholderDetailsLoading(true)
      try {
        const {
          data: { data, success },
        } = await getSharholderDetails(shareholderId, companyId)
        if (success) {
          setShareholderDetails(data)
          setImgName(data?.individual?.profileImage?.name)
          setCountryId(data?.individual?.country?.id)
          setShareholderDetailsLoading(false)
        }
      } catch (error) {
        console.error('Error fetching countries:', error)
      } finally {
        setShareholderDetailsLoading(false)
      }
    }
    fetchShareholder()
  }, [shareholderId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (shareholderDetails?.documents.length > 0 && isNotInitialized) {
      setFiles(
        shareholderDetails?.documents.map(({ fileId, name }: { fileId: string; name: string }) => ({
          id: fileId,
          name,
        }))
      )
    }
  }, [isNotInitialized, shareholderDetails?.documents])

  const sidebarOptions = [
    { title: formatMessage({ id: 'Personal Details' }) },
    { title: formatMessage({ id: 'Address' }) },
    { title: formatMessage({ id: 'Other Details' }) },
    { title: formatMessage({ id: 'Documents' }) },
  ]

  const [files, setFiles] = useState<any>([])

  const deleteFile = () => {
    if (!deleteFileId) return
    setDeleteLoading(true)
    setFiles(files.filter((file: any) => file.id !== deleteFileId))
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        'fileIds',
        files.filter((file: any) => file.id !== deleteFileId).map((file: any) => file.id)
      )
    }
    setDeleteLoading(false)
    setDeleteShowModal(false)
    toast.success('Document deleted successfully')
  }

  const handleClearFormData = () => {
    setClearFormDataLoading(true)
    if (formikRef.current) {
      formikRef.current.resetForm()
      setIndividualStakeholders(null)
    }
    setClearFormDataShowModal(false)
    setClearFormDataLoading(false)
  }

  const userSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(1, 'First name must be at least 2 characters')
      .max(50, 'First name must be 50 characters or less')
      .nullable()
      .required('First name is required'),

    lastName: Yup.string()
      .min(1, 'Last name must be at least 2 characters')
      .max(50, 'Last name must be 50 characters or less')
      .nullable()
      .required('Last name is required'),

    email: Yup.string().email('Invalid email address').nullable().required('Email is required'),
    workCompanyName: Yup.string()
      .nullable()
      .max(200, 'Company name must be 200 characters or less')
      .required('Company name is required'),
    stakeholderCategory: Yup.object().required('Shareholder category is required').nullable(),
    website: Yup.string().url('Invalid url').nullable(),
    nationality: Yup.object()
      .nullable()
      .test('required', 'Nationality is required', function (value: any, ctx: any) {
        console.log(
          ctx,
          !ctx.originalValue,
          ctx.parent.sidebar,
          'ctx',
          (ctx.parent.sidebar === 3 || ctx.parent.sidebar === 4) &&
          (!ctx.originalValue || ctx.originalValue === '')
        )

        if (
          (ctx.parent.sidebar === 3 || ctx.parent.sidebar === 4) &&
          (!ctx.originalValue || ctx.originalValue === '')
        ) {
          console.log('inside')

          return false
        }
        return true
      }),
    phone: Yup.string()
      .nullable()
      .test('phone-number-valid', 'Invalid phone number', function (value, ctx: any) {
        if (!value || value === '') return false

        const selectedPhoneCode = ctx.parent.phoneCode
        const selectedCountryCode = phoneCodesOptions.find(
          (option: any) => option.dial_code === selectedPhoneCode
        )?.code

        if (phoneCodesOptions.length === 0 && ctx.originalValue) {
          return true
        }

        try {
          const phoneNumber = String(ctx.originalValue)
          const parsedNumber = parsePhoneNumberFromString(phoneNumber, selectedCountryCode)

          return isValidPhoneNumber(parsedNumber?.number as string)
        } catch (error) {
          return false
        }
      }),
    address1: Yup.string()
      .nullable()
      .test('maxLength', 'Address 1 cannot be more than 300 characters', function (value) {
        if (!value || value?.length === 0) return true
        return !!(value && value.length <= 300)
      }),

    address2: Yup.string()
      .nullable()
      .test('maxLength', 'Address 2 cannot be more than 300 characters', function (value) {
        if (!value || value?.length === 0) return true
        return !!(value && value.length <= 300)
      }),
    guardianName: Yup.string()
      .nullable()
      .test('is-required-guardian-name', 'Guardian name is required', function (value) {
        const { dateOfBirth, sidebar } = this.parent
        if (
          (sidebar === 3 || sidebar === 4) &&
          dateOfBirth &&
          !isOlderThan18(dateOfBirth) &&
          (!value || value.trim() === '')
        ) {
          return this.createError({
            message: 'Guardian name is required',
          })
        }
        return true
      })
      .min(1, 'Guardian name must be at least 2 characters')
      .max(50, 'Guardian name must be 50 characters or less'),

    guardianRelationship: Yup.string()
      .nullable()
      .test(
        'is-required-guardian-relationship',
        'Guardian relationship is required',
        function (value) {
          const { dateOfBirth, sidebar } = this.parent
          if (
            (sidebar === 3 || sidebar === 4) &&
            dateOfBirth &&
            !isOlderThan18(dateOfBirth) &&
            (!value || value.trim() === '')
          ) {
            return this.createError({
              message: 'Guardian relationship is required',
            })
          }
          return true
        }
      )
      .min(1, 'Guardian relationship must be at least 2 characters')
      .max(50, 'Guardian relationship must be 50 characters or less'),

    guardianEmail: Yup.string()
      .nullable()
      .email('Invalid email address')
      .test('is-required-guardian-email', 'Guardian email is required', function (value) {
        const { dateOfBirth, sidebar } = this.parent
        if (
          (sidebar === 3 || sidebar === 4) &&
          dateOfBirth &&
          !isOlderThan18(dateOfBirth) &&
          (!value || value.trim() === '')
        ) {
          return this.createError({
            message: 'Guardian email is required',
          })
        }
        return true
      }),

    guardianPhoneCode: Yup.string()
      .nullable()
      .when('dateOfBirth', {
        is: (dateOfBirth: string) => !isOlderThan18(dateOfBirth),
        then: Yup.string().required('Guardian phone code is required'),
      }),
    guardianPhoneNumber: Yup.string()
      .nullable()
      .test('phone-number-valid', 'Invalid phone number', function (value, ctx: any) {
        if (!value || value === '') return true
        const selectedPhoneCode = ctx.parent.guardianPhoneCode
        const selectedCountryCode = phoneCodesOptions.find(
          (option: any) => option.dial_code === selectedPhoneCode
        )?.code

        if (phoneCodesOptions.length === 0 && ctx.originalValue) {
          return true
        }

        try {
          const phoneNumber = String(ctx.originalValue)
          const parsedNumber = parsePhoneNumberFromString(phoneNumber, selectedCountryCode)

          return isValidPhoneNumber(parsedNumber?.number as string)
        } catch (error) {
          return false
        }
      }),
  })

  const initialValues = {
    sidebar: 1,
    profileImage: shareholderDetails?.individual?.profileImage?.id || '',
    isEmployee: shareholderDetails?.isEmployee?.toString() || 'false',
    firstName: shareholderDetails?.individual?.firstName || '',
    lastName: shareholderDetails?.individual?.lastName || '',
    workCompanyName: shareholderDetails?.individual?.companyName || '',
    stakeholderCategory: shareholderDetails?.stakeholderCategory
      ? shareholdersCategoryOptions.find(
        (category) => category.value === shareholderDetails?.stakeholderCategory
      )
      : '',
    email: shareholderDetails?.individual?.email || '',
    phoneCode: shareholderDetails?.individual?.phoneNumber
      ? shareholderDetails?.individual?.phoneNumber.split(' ')[0]
      : '+91',
    phone: shareholderDetails?.individual?.phoneNumber
      ? shareholderDetails?.individual?.phoneNumber.split(' ')[1]
      : '',
    dateOfBirth: shareholderDetails?.individual?.dateOfBirth || '',
    commencementDate: shareholderDetails?.commencementDate || '',
    separationDate: shareholderDetails?.separationDate || '',
    reasonForSeparation: shareholderDetails?.reasonForSeparation || '',
    address1: shareholderDetails?.individual?.address1 || '',
    address2: shareholderDetails?.individual?.address2 || '',
    country: shareholderDetails?.individual?.country || '',
    state: shareholderDetails?.individual?.state || '',
    city: shareholderDetails?.individual?.city || '',
    zipCode: shareholderDetails?.individual?.zipCode || '',
    designation: shareholderDetails?.designation || '',
    employeeId: shareholderDetails?.employeeId || '',
    nationality: shareholderDetails?.individual?.nationality || '',
    presentCountry: shareholderDetails?.presentCountry || '',
    govtIssuedIdType: shareholderDetails?.individual?.govtIssuedIdType || '',
    govtIssuedIdNumber: shareholderDetails?.individual?.govtIssuedIdNumber || '',
    website: shareholderDetails?.individual?.website || '',
    referredBy: shareholderDetails?.referredBy || '',
    exCompanies: shareholderDetails?.exCompanies ? shareholderDetails?.exCompanies.split(',') : '',
    lastHeardDate: shareholderDetails?.lastHeardDate || '',
    fileIds: shareholderDetails?.documents?.map((document: any) => document.fileId) || [],
    guardianName: shareholderDetails?.guardianName || '',
    guardianRelationship: shareholderDetails?.guardianRelationship || '',
    guardianEmail: shareholderDetails?.guardianEmail || '',
    guardianPhoneCode: shareholderDetails?.guardianPhoneCode || '+91',
    guardianPhoneNumber: shareholderDetails?.guardianPhoneNumber || '',
  }

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const rawPayload = {
      entityType: ShareholdersTypes.INDIVIDUAL,
      profileImage: values?.profileImage,
      isEmployee: parseBoolean(values?.isEmployee),
      firstName: values?.firstName,
      lastName: values?.lastName,
      workCompanyName: values?.workCompanyName,
      stakeholderCategory: values?.stakeholderCategory?.value
        ? values?.stakeholderCategory.value
        : null,
      email: values?.email,
      phoneNumber: values?.phone,
      phoneCode: values?.phoneCode,
      dateOfBirth: values?.dateOfBirth,
      commencementDate: values?.commencementDate,
      separationDate: values?.separationDate,
      reasonForSeparation: values?.reasonForSeparation,
      address1: values?.address1,
      address2: values?.address2,
      country: values?.country?.value || values?.country?.id,
      state: values?.state?.value ? parseInt(values?.state?.value) : null,
      city: values?.city,
      zipCode: values?.zipCode,
      designation: values?.designation,
      employeeId: values?.employeeId,
      nationality: values?.nationality?.value || values?.nationality?.id,
      guardianName: values?.guardianName,
      guardianRelationship: values?.guardianRelationship,
      guardianEmail: values?.guardianEmail,
      guardianPhoneNumber: values?.guardianPhoneNumber,
      guardianPhoneCode: values?.guardianPhoneCode,
      presentCountry: values?.presentCountry?.value || values?.presentCountry?.id,
      govtIssuedIdType: values?.govtIssuedIdType?.value ?? null,
      govtIssuedIdNumber: values?.govtIssuedIdNumber,
      website: values?.website,
      referredBy: values?.referredBy,
      exCompanies:
        Array.isArray(values?.exCompanies) && values?.exCompanies?.length > 0
          ? values?.exCompanies.join(',')
          : values?.exCompanies
            ? values?.exCompanies
            : null,
      lastHeardDate: values?.lastHeardDate,
      fileIds: values?.fileIds,
      individualId: individualStakeholders ? individualStakeholders?.individualId : null,
      isEditPopulatedData: individualStakeholders ? true : null,
    }

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '' && value.length !== 0
      )
    )

    try {
      if (!companyId) {
        return
      }
      setLoading(true)
      if (shareholderId && shareholderDetails) {
        const {
          data: { success, errors },
        } = await updateShareholder(payload, companyId, shareholderId)

        if (success) {
          resetForm()
          setImgName('')
          setFiles([])
          setShareholderDetails(null)
          navigate('/stakeholders/stakeholders-and-investors?tab=shareholders-and-Investors')
          setLoading(false)
          toast.success(formatMessage({ id: 'Shareholder updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ShareholderUpdationSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                shareholder_id: shareholderId,
                entity_type: ShareholdersTypes.INDIVIDUAL,
                profile_image: values?.profileImage,
                is_employee: parseBoolean(values?.isEmployee),
                shareholder_first_ame: values?.firstName,
                shareholder_last_name: values?.lastName,
                work_company_name: values?.workCompanyName,
                stakeholder_category: values?.stakeholderCategory?.value
                  ? values?.stakeholderCategory.value
                  : null,
                shareholder_email: values?.email,
                date_of_birth: values?.dateOfBirth,
                commencement_date: values?.commencementDate,
                separation_date: values?.separationDate,
                designation: values?.designation,
                employee_id: values?.employeeId,
                nationality: values?.nationality?.value || values?.nationality?.id,
                present_country: values?.presentCountry?.value || values?.presentCountry?.id,
                file_ids: values?.fileIds,
                individual_id: individualStakeholders ? individualStakeholders?.individualId : null,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ShareholderUpdationFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                shareholder_id: shareholderId,
                error: errors[0],
              },
            },
          })
        }
      } else {
        const {
          data: { success, errors },
        } = await createShareholder(payload, companyId)

        if (success) {
          toast.success(formatMessage({ id: 'Shareholder created successfully' }))
          resetForm()
          setImgName('')
          setFiles([])

          setShareholderDetails(null)
          setLoading(false)
          setIndividualStakeholders(null)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ShareholderCreationSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                entity_type: ShareholdersTypes.INDIVIDUAL,
                profile_image: values?.profileImage,
                is_employee: parseBoolean(values?.isEmployee),
                shareholder_first_ame: values?.firstName,
                shareholder_last_name: values?.lastName,
                work_company_name: values?.workCompanyName,
                stakeholder_category: values?.stakeholderCategory?.value
                  ? values?.stakeholderCategory.value
                  : null,
                shareholder_email: values?.email,
                date_of_birth: values?.dateOfBirth,
                commencement_date: values?.commencementDate,
                separation_date: values?.separationDate,
                designation: values?.designation,
                employee_id: values?.employeeId,
                nationality: values?.nationality?.value || values?.nationality?.id,
                present_country: values?.presentCountry?.value || values?.presentCountry?.id,
                file_ids: values?.fileIds,
                individual_id: individualStakeholders ? individualStakeholders?.individualId : null,
              },
            },
          })
          if (iscaptible) {
            navigate('/captable-management/scenarios/create-new-scenario')
          } else {
            navigate('/stakeholders/stakeholders-and-investors?tab=shareholders-and-Investors')
          }
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ShareholderCreationFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.error('Error:', err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ShareholderCreationFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='d-flex flex-md-row flex-column'>
        <div className='sidebar-investor-db col-md-1 d-none d-md-flex'>
          {sidebarOptions.map((sideTabs, index) => (
            <ul
              key={index}
              className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer'
            >
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === index + 1
                  ? 'border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => {
                  if (index === 1) {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.ShareholderCreationPersonalDetailsPageAccessSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                        },
                      },
                    })
                  } else if (index === 2) {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.ShareholderCreationPersonalAddressPageAccessSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                        },
                      },
                    })
                  } else if (index === 3) {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.ShareholderCreationPersonalOtherDetailsPageAccessSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                        },
                      },
                    })
                  } else if (index === 4) {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.ShareholderCreationPersonalDocumentsPageAccessSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                        },
                      },
                    })
                  }
                  setSidebar(index + 1)
                  if (formikRef.current) formikRef.current.setFieldValue('sidebar', index + 1)
                }}
              >
                {formatMessage({ id: sideTabs.title })}
              </li>
            </ul>
          ))}
        </div>
        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent mt-0 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                  style={{ display: 'flex', flexWrap: 'nowrap' }}
                >
                  <div>
                    <li
                      key={index}
                      className={
                        `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => {
                        if (index === 1) {
                          TagManager.dataLayer({
                            dataLayer: {
                              event:
                                GTMEvent.ShareholderCreationPersonalDetailsPageAccessSuccessful,
                              action: 'normal',
                              metadata: {
                                company_id: companyId,
                                user_id: currentUser?.userId,
                                email: currentUser?.email,
                              },
                            },
                          })
                        } else if (index === 2) {
                          TagManager.dataLayer({
                            dataLayer: {
                              event:
                                GTMEvent.ShareholderCreationPersonalAddressPageAccessSuccessful,
                              action: 'normal',
                              metadata: {
                                company_id: companyId,
                                user_id: currentUser?.userId,
                                email: currentUser?.email,
                              },
                            },
                          })
                        } else if (index === 3) {
                          TagManager.dataLayer({
                            dataLayer: {
                              event:
                                GTMEvent.ShareholderCreationPersonalOtherDetailsPageAccessSuccessful,
                              action: 'normal',
                              metadata: {
                                company_id: companyId,
                                user_id: currentUser?.userId,
                                email: currentUser?.email,
                              },
                            },
                          })
                        } else if (index === 4) {
                          TagManager.dataLayer({
                            dataLayer: {
                              event:
                                GTMEvent.ShareholderCreationPersonalDocumentsPageAccessSuccessful,
                              action: 'normal',
                              metadata: {
                                company_id: companyId,
                                user_id: currentUser?.userId,
                                email: currentUser?.email,
                              },
                            },
                          })
                        }
                        setSidebar(index + 1)
                      }}
                    >
                      {formatMessage({ id: sideTabs.title })}
                    </li>
                  </div>
                </ul>
              </>
            ))}
          </div>
        </div>

        <div className='rounded-2 bg-white p-8 w-100'>
          <Formik
            initialValues={initialValues}
            validationSchema={userSchema}
            innerRef={formikRef}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            validateOnMount
          >
            {(formik: any) => {
              setCountryId(formik?.values?.country?.value)

              return (
                <Form>
                  {sidebar === 1 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({ id: 'How to Add an Individual Shareholder?' })}
                          desc={formatMessage({
                            id: `Easily add personal, address, and critical details, along with important documents, for individual shareholders on the ${brandingConfig.brandName} portal to maintain comprehensive and organized records.`,
                          })}
                          slug={brandingConfig.helpLinks.addShareholderIndividual}
                        />
                      </div>
                      <div className='mb-4'>
                        <h2 className='font-size-16'>{formatMessage({ id: 'Personal Details' })}</h2>

                        <div className='d-md-flex flex-md-column my-8'>
                          <div className='d-flex form-label  text-dark font-size-13'>
                            {formatMessage({ id: 'Is Employee' })}{' '}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.ISEMPLOYEE',
                              })}
                            />
                          </div>
                          <div className='d-flex align-items-center gap-4'>
                            <div className='d-flex align-items-center gap-1'>
                              <input
                                type='radio'
                                defaultChecked={formik?.values?.isEmployee === 'true'}
                                id='employee-yes'
                                name='isEmployee'
                                value='true'
                                onChange={formik.handleChange}
                                width={48}
                                height={48}
                              />
                              <label htmlFor='employee-yes'>{formatMessage({ id: 'Yes' })}</label>
                            </div>
                            <div className='d-flex align-items-center gap-1'>
                              <input
                                type='radio'
                                id='employee-no'
                                defaultChecked={formik?.values?.isEmployee === 'false'}
                                name='isEmployee'
                                onChange={formik.handleChange}
                                value='false'
                                width={48}
                                height={48}
                              />
                              <label htmlFor='employee-no'>{formatMessage({ id: 'No' })}</label>
                            </div>
                          </div>
                        </div>

                        <div>
                          <div className='d-flex form-label  text-dark font-size-13'>
                            {formatMessage({ id: 'Profile Pic/Logo' })}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.PROFILE_PIC',
                              })}
                            />
                          </div>
                          <div className='card position-relative d-inline-flex justify-content-center '>
                            {shareholderDetailsLoading || stakeHoldersDataLoading ? (
                              <Skeleton
                                height={120}
                                width={120}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            ) : (
                              <DisplayImage
                                imgName={imgName ? imgName : 'dummy'}
                                height='120px'
                                width='120px'
                                fit='contain'
                                alt='profile'
                                className='rounded'
                              />
                            )}

                            <div
                              className='position-absolute '
                              style={{ top: 0, right: 0 }}
                              onClick={() => {
                                TagManager.dataLayer({
                                  dataLayer: {
                                    event: GTMEvent.ShareholderCreationPictureUploadFailed,
                                    action: 'normal',
                                    metadata: {
                                      company_id: companyId,
                                      user_id: currentUser?.userId,
                                      email: currentUser?.email,
                                    },
                                  },
                                })
                                setModalStatus(true)
                              }}
                            >
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                                alt='pencil icon'
                                className='cursor-pointer'
                              />
                            </div>
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'profileimg', isProtected: false }}
                              modalStatus={modalStatus}
                              handleClose={() => setModalStatus(false)}
                              handleSuccess={(id: number, name: string) => {
                                setImgName(name)
                                formik.setFieldValue('profileImage', id)
                                TagManager.dataLayer({
                                  dataLayer: {
                                    event: GTMEvent.ShareholderCreationPictureUploadSuccessful,
                                    action: 'normal',
                                    metadata: {
                                      company_id: companyId,
                                      user_id: currentUser?.userId,
                                      email: currentUser?.email,
                                      image_name: name,
                                      image_id: id,
                                    },
                                  },
                                })
                              }}
                              resourceType='all'
                            />
                          </div>
                          <p className='font-size-12 text-muted' style={{ maxWidth: '120px' }}>
                            {formatMessage({ id: 'Max size 2mb, supported format jpg, png' })}
                          </p>
                        </div>

                        {shareholderDetailsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <UserSearchTextInput
                                  label={formatMessage({ id: 'First Name' })}
                                  fieldName='firstName'
                                  toolTipText={formatMessage({
                                    id: 'Add first name of the founder here.',
                                  })}
                                  dropdownData={dropDownData}
                                  dropdownDataLoading={dropdownDataLoading}
                                  openUserDropdown={openUserDropdown}
                                  onSelect={(id: string) => {
                                    setOpenUserDropdown(false)
                                    fetchIndividualStakeholders(id, formik)
                                  }}
                                  onNewEntryButtonClick={() => {
                                    setOpenUserDropdown(false)
                                    setIndividualStakeholders(null)
                                    setNewEntryButtonClicked(true)
                                  }}
                                  fieldClicked={fieldClicked}
                                  isDisabled={individualStakeholders?.firstName}
                                  setOpenUserDropdown={setOpenUserDropdown}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter First Name' })}
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, shareholderDetails)
                                  }
                                  ariaLabel='firstName'
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>

                              <div className='col-md-6 col-12'>
                                <UserSearchTextInput
                                  label={formatMessage({ id: 'Last Name' })}
                                  fieldName='lastName'
                                  toolTipText={formatMessage({
                                    id: 'Add last name of the founder here.',
                                  })}
                                  dropdownData={dropDownData}
                                  dropdownDataLoading={dropdownDataLoading}
                                  openUserDropdown={openUserDropdown}
                                  onSelect={(id: string) => {
                                    setOpenUserDropdown(false)
                                    fetchIndividualStakeholders(id, formik)
                                  }}
                                  onNewEntryButtonClick={() => {
                                    setOpenUserDropdown(false)
                                    setIndividualStakeholders(null)
                                    setNewEntryButtonClicked(true)
                                  }}
                                  fieldClicked={fieldClicked}
                                  setOpenUserDropdown={setOpenUserDropdown}
                                  isDisabled={individualStakeholders?.lastName}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Last Name' })}
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, shareholderDetails)
                                  }
                                  ariaLabel='lastName'
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Company Name' })}
                                  fieldName='workCompanyName'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Company Name' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.COMPANY_NAME',
                                  })}
                                  isStarRequired={true}
                                  ariaLabel='workCompanyName'
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, shareholderDetails)
                                  }
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Stakeholder Category' })}
                                  fieldName='stakeholderCategory'
                                  placeholder={formatMessage({
                                    id: 'Select Stakeholder Category',
                                  })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.STAKHOLDER_CATEGORY',
                                  })}
                                  options={shareholdersCategoryOptions}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Email Id' })}
                                  isDisabled={individualStakeholders?.email}
                                  fieldName='email'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Email ID' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.EMAIL',
                                  })}
                                  isStarRequired={true}
                                  ariaLabel='email'
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, shareholderDetails)
                                  }
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <InputWithPhone
                                  label={formatMessage({ id: 'Phone' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.PHONE',
                                  })}
                                  fieldName='phone'
                                  placeholder={formatMessage({ id: 'Enter Phone Number' })}
                                  placeholderSelect='Select'
                                  disabled={
                                    individualStakeholders?.phoneCode &&
                                    individualStakeholders?.phoneNumber
                                  }
                                  formik={formik}
                                  options={phoneCodesOptions}
                                  selectOptionFieldName='phoneCode'
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, shareholderDetails)
                                  }
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Date of birth' })}
                                  isDisabled={individualStakeholders?.dateOfBirth}
                                  fieldName='dateOfBirth'
                                  isDateOfBirth={true}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Select Date of birth' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.DOB',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Commencement Date' })}
                                  fieldName='commencementDate'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Select Commencement Date' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.COMMENCEMENT_DATE',
                                  })}
                                  isStarRequired={false}
                                  isDateOfBirth={true}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Date of Separation' })}
                                  fieldName='separationDate'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Select Date of Separation' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.SEPARATION_DATE',
                                  })}
                                  isGreaterThanCommencementDate={true}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Reason for Separation' })}
                                  fieldName='reasonForSeparation'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Reason for Separation' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.SEPARATION_REASON',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                            </div>

                            <div className='gap-2 mt-10'>
                              <div className='d-flex justify-content-md-between flex-column flex-md-row gap-2 gap-md-4'>
                                <div>
                                  {!shareholderDetails && (
                                    <button
                                      type='button'
                                      onClick={() => {
                                        if (individualStakeholders) {
                                          setClearFormDataShowModal(true)
                                        } else {
                                          resetFields(formik, shareholderSidebarFields)
                                        }
                                      }}
                                      disabled={
                                        !individualStakeholders &&
                                        Object.entries(formik.values)
                                          .filter(([key]) =>
                                            shareholderSidebarFields[
                                              formik.values.sidebar as 1 | 2 | 3
                                            ]?.includes(key)
                                          )
                                          .filter(([key]) => !['phoneCode'].includes(key))
                                          .every(
                                            ([_, value]) =>
                                              value === null ||
                                              value === '' ||
                                              (Array.isArray(value) && value.length === 0)
                                          )
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                    >
                                      {formatMessage({
                                        id: individualStakeholders ? 'Clear All' : 'Clear',
                                      })}
                                    </button>
                                  )}
                                </div>

                                <div>
                                  <button
                                    className='btn bg-light custom-button-property border border-1 mb-md-4 me-3 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1'
                                    onClick={() =>
                                      navigate(
                                        '/stakeholders/stakeholders-and-investors?tab=shareholders-and-Investors'
                                      )
                                    }
                                  >
                                    {formatMessage({ id: 'Cancel' })}
                                  </button>
                                  <button
                                    className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    type='button'
                                    onClick={() => {
                                      setSidebar(sidebar + 1)
                                      if (formikRef.current)
                                        formikRef.current.setFieldValue('sidebar', sidebar + 1)

                                      TagManager.dataLayer({
                                        dataLayer: {
                                          event:
                                            GTMEvent.ShareholderCreationPersonalAddressPageAccessSuccessful,
                                          action: 'normal',
                                          metadata: {
                                            company_id: companyId,
                                            user_id: currentUser?.userId,
                                            email: currentUser?.email,
                                          },
                                        },
                                      })
                                    }}
                                    disabled={
                                      individualStakeholders
                                        ? false
                                        : edit === 'true'
                                          ? !formik.isValid
                                          : !formik.isValid || !formik.dirty
                                    }
                                  >
                                    {formatMessage({ id: 'Next' })}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 2 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className=''>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({ id: 'How to Add an Individual Shareholder?' })}
                          desc={formatMessage({
                            id: `Easily add personal, address, and critical details, along with important documents, for individual shareholders on the ${brandingConfig.brandName} portal to maintain comprehensive and organized records.`,
                          })}
                          slug={brandingConfig.helpLinks.addShareholderIndividual}
                        />
                      </div>

                      <div className='mb-4'>
                        <h2 className='font-size-16'>
                          {formatMessage({ id: 'Investor’s Official Address' })}
                        </h2>

                        {shareholderDetailsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Address Line 1' })}
                                  isDisabled={individualStakeholders?.address1}
                                  fieldName='address1'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Address Line 1' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.ADDRESS_LANE_1',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Address Line 2' })}
                                  isDisabled={individualStakeholders?.address2}
                                  fieldName='address2'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Address Line 2' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.ADDRESS_LANE_2',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Country' })}
                                  fieldName='country'
                                  placeholder={formatMessage({ id: 'Select Country' })}
                                  formik={formik}
                                  disabled={individualStakeholders?.country}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.COUNTRY',
                                  })}
                                  options={countryOptions}
                                  isStarRequired={true}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                {stateDataLoading ? (
                                  <div className='col-md-5 mb-10 mb-md-0'>
                                    <div className='w-50'>
                                      <Skeleton
                                        height={20}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                      />
                                    </div>
                                    <div className='mt-2'>
                                      <Skeleton
                                        height={30}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <SelectSearchInput
                                    label={formatMessage({ id: 'State' })}
                                    fieldName='state'
                                    placeholder={formatMessage({ id: 'Select State' })}
                                    formik={formik}
                                    toolTipText={formatMessage({
                                      id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.STATE',
                                    })}
                                    disabled={individualStakeholders?.state}
                                    options={stateOptions}
                                    isStarRequired={true}
                                  />
                                )}
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'City' })}
                                  fieldName='city'
                                  isDisabled={individualStakeholders?.city}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter City' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.CITY',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'zipcode' })}
                                  fieldName='zipCode'
                                  formik={formik}
                                  isDisabled={individualStakeholders?.zipCode}
                                  placeholder={formatMessage({ id: 'Enter Zipcode' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.ZIPCODE',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                            </div>

                            <div className=' gap-2 mt-10'>
                              <div className='d-flex flex-column flex-md-row justify-content-md-between gap-2 gap-md-4'>
                                <div>
                                  {!shareholderDetails && (
                                    <button
                                      type='button'
                                      onClick={() => {
                                        if (individualStakeholders) {
                                          setClearFormDataShowModal(true)
                                        } else {
                                          resetFields(formik, shareholderSidebarFields)
                                        }
                                      }}
                                      disabled={Object.entries(formik.values)
                                        .filter(([key]) =>
                                          shareholderSidebarFields[
                                            formik.values.sidebar as 1 | 2 | 3
                                          ]?.includes(key)
                                        )
                                        .every(
                                          ([_, value]) =>
                                            value === null ||
                                            value === '' ||
                                            (Array.isArray(value) && value.length === 0) // Handle empty arrays as empty
                                        )}
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                    >
                                      {formatMessage({
                                        id: individualStakeholders ? 'Clear All' : 'Clear',
                                      })}
                                    </button>
                                  )}
                                </div>

                                <div>
                                  <button
                                    className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                    onClick={() => {
                                      setSidebar(sidebar - 1)
                                      if (formikRef.current) {
                                        formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                      }
                                    }}
                                  >
                                    {formatMessage({ id: 'Back' })}
                                  </button>
                                  <button
                                    className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    type='button'
                                    onClick={() => {
                                      setSidebar(sidebar + 1)
                                      if (formikRef.current)
                                        formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      TagManager.dataLayer({
                                        dataLayer: {
                                          event:
                                            GTMEvent.ShareholderCreationPersonalOtherDetailsPageAccessSuccessful,
                                          action: 'normal',
                                          metadata: {
                                            company_id: companyId,
                                            user_id: currentUser?.userId,
                                            email: currentUser?.email,
                                          },
                                        },
                                      })
                                    }}
                                    disabled={
                                      individualStakeholders
                                        ? false
                                        : edit === 'true'
                                          ? !formik.isValid
                                          : !formik.isValid || !formik.dirty
                                    }
                                  >
                                    {formatMessage({ id: 'Next' })}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}{' '}
                  {sidebar === 3 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className=''>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({ id: 'How to Add an Individual Shareholder?' })}
                          desc={formatMessage({
                            id: `Easily add personal, address, and critical details, along with important documents, for individual shareholders on the ${brandingConfig.brandName} portal to maintain comprehensive and organized records.`,
                          })}
                          slug={brandingConfig.helpLinks.addShareholderIndividual}
                        />
                      </div>

                      <div className='mb-4'>
                        <h2 className='font-size-16'>
                          {formatMessage({ id: 'Investor’s Other Details' })}
                        </h2>

                        {shareholderDetailsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'designation' })}
                                  fieldName='designation'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Designation' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.DESIGNATION',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'employee ID' })}
                                  fieldName='employeeId'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Employee ID' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.EMPLOYEE_ID',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Nationality' })}
                                  fieldName='nationality'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Nationality' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.NATIONALITY',
                                  })}
                                  disabled={individualStakeholders?.nationality}
                                  options={countryOptions}
                                  isStarRequired={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Present Country (if any)' })}
                                  fieldName='presentCountry'
                                  placeholder={formatMessage({
                                    id: 'Select Present Country',
                                  })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.PRESENT_COUNTRY',
                                  })}
                                  options={countryOptions}
                                  isStarRequired={true}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectHeaderDropDown
                                  label={formatMessage({ id: 'Govt. issued ID type' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.GOVT_ID_TYPE',
                                  })}
                                  placeholder='Select Govt. issued ID type'
                                  fieldName='govtIssuedIdType'
                                  formik={formik}
                                  isStarRequired
                                  dropdownOptions={govtIdOptions}
                                  disabled={individualStakeholders?.govtIssuedIdType}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Govt. Issued ID Number' })}
                                  fieldName='govtIssuedIdNumber'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Govt. Issued ID Number' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.GOVT_ID_NUMBER',
                                  })}
                                  isStarRequired={false}
                                  isDisabled={individualStakeholders?.govtIssuedIdNumber}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Website' })}
                                  fieldName='website'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Website url' })}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.WEBSITE',
                                  })}
                                  isStarRequired={false}
                                  isDisabled={individualStakeholders?.website}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Referred By (if any)' })}
                                  fieldName='referredBy'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Referee Name' })}
                                  toolTipText={formatMessage({
                                    id: 'Add the name of the person who referred the investor (if applicable)',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TagifyInput
                                  label={formatMessage({ id: 'Ex Companies' })}
                                  placeholder={formatMessage({ id: 'Enter ex companies' })}
                                  tooltip={formatMessage({
                                    id: 'Add ex compianes of the shareholder.',
                                  })}
                                  fieldName='exCompanies'
                                  formik={formik}
                                  disabled={individualStakeholders?.exCompanies}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Last Heard (if any)' })}
                                  fieldName='lastHeardDate'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Last Heard Date' })}
                                  isDateOfBirth={true}
                                  toolTipText={formatMessage({
                                    id: 'GLOBAL.TOOLTIP.ADD_STAKEHOLDER.INDIVIDUAL.LAST_HEARD_DATE',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              {formik.values.dateOfBirth &&
                                formik.values.dateOfBirth.length > 0 &&
                                !isOlderThan18(formik.values.dateOfBirth) && (
                                  <>
                                    <>
                                      <div className='font-size-16 fw-600 mb-3'>
                                        {formatMessage({ id: 'Guardian Details' })}
                                      </div>
                                      <div className='shareholder-minor p-4 font-size-14 mb-5 ms-3 d-flex align-items-center'>
                                        <img
                                          className='me-2'
                                          src={tooltipIcon}
                                          alt='tooltip-icon'
                                        />
                                        {formatMessage({
                                          id: `The shareholder is a minor (under 18 years of age). Kindly
                                        provide the guardian's information.`,
                                        })}
                                      </div>
                                    </>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='string'
                                        label={formatMessage({ id: 'Guardian Name' })}
                                        fieldName='guardianName'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: "Enter guardian's full name",
                                        })}
                                        toolTipText={formatMessage({
                                          id: "Enter guardian's full name",
                                        })}
                                        isStarRequired={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='string'
                                        label={formatMessage({ id: "Guardian's Relation" })}
                                        fieldName='guardianRelationship'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: "Enter guardian's Relation with this minor",
                                        })}
                                        toolTipText={formatMessage({
                                          id: "Enter guardian's Relation with this minor",
                                        })}
                                        isStarRequired={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='email'
                                        label={formatMessage({ id: 'Guardian Email ID' })}
                                        fieldName='guardianEmail'
                                        formik={formik}
                                        placeholder={formatMessage({ id: "Enter guardian's email" })}
                                        toolTipText={formatMessage({
                                          id: "Enter guardian's email",
                                        })}
                                        isStarRequired={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <InputWithPhone
                                        fieldName='guardianPhoneNumber'
                                        selectOptionFieldName='guardianPhoneCode'
                                        label={formatMessage({ id: 'Guardian Phone' })}
                                        placeholder={formatMessage({ id: 'Enter Phone Number' })}
                                        placeholderSelect='+91'
                                        formik={formik}
                                        options={phoneCodesOptions}
                                        toolTipText={formatMessage({
                                          id: 'Select the country code and add phone number of the guardian.',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                        onFocus={formik.handleFocus}
                                      />
                                    </div>
                                  </>
                                )}
                            </div>

                            <div className='gap-2 mt-10'>
                              <div className='d-flex flex-md-row justify-content-md-between flex-column flex-md-row gap-2 gap-md-4'>
                                <div>
                                  {!shareholderDetails && (
                                    <button
                                      type='button'
                                      onClick={() => {
                                        if (individualStakeholders) {
                                          setClearFormDataShowModal(true)
                                        } else {
                                          resetFields(formik, shareholderSidebarFields)
                                        }
                                      }}
                                      disabled={Object.entries(formik.values)
                                        .filter(([key]) =>
                                          shareholderSidebarFields[
                                            formik.values.sidebar as 1 | 2 | 3
                                          ]?.includes(key)
                                        )
                                        .every(
                                          ([_, value]) =>
                                            value === null ||
                                            value === '' ||
                                            (Array.isArray(value) && value.length === 0) // Handle empty arrays as empty
                                        )}
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                    >
                                      {formatMessage({
                                        id: individualStakeholders ? 'Clear All' : 'Clear',
                                      })}
                                    </button>
                                  )}
                                </div>
                                <div>
                                  <button
                                    className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                    onClick={() => {
                                      setSidebar(sidebar - 1)
                                      if (formikRef.current) {
                                        formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                      }
                                    }}
                                  >
                                    {formatMessage({ id: 'Back' })}
                                  </button>
                                  <button
                                    className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    type='button'
                                    onClick={() => {
                                      setSidebar(sidebar + 1)
                                      if (formikRef.current)
                                        formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      TagManager.dataLayer({
                                        dataLayer: {
                                          event:
                                            GTMEvent.ShareholderCreationPersonalDocumentsPageAccessSuccessful,
                                          action: 'normal',
                                          metadata: {
                                            company_id: companyId,
                                            user_id: currentUser?.userId,
                                            email: currentUser?.email,
                                          },
                                        },
                                      })
                                    }}
                                    disabled={
                                      individualStakeholders
                                        ? false
                                        : edit === 'true'
                                          ? !formik.isValid
                                          : !formik.isValid || !formik.dirty
                                    }
                                  >
                                    {formatMessage({ id: 'Next' })}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}{' '}
                  {sidebar === 4 && (
                    <>
                      <div className=''>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({ id: 'How to Add an Individual Shareholder?' })}
                          desc={formatMessage({
                            id: `Easily add personal, address, and critical details, along with important documents, for individual shareholders on the ${brandingConfig.brandName} portal to maintain comprehensive and organized records.`,
                          })}
                          slug={brandingConfig.helpLinks.addShareholderIndividual}
                        />
                      </div>

                      <div className=''>
                        <h2 className='font-size-16'>
                          {formatMessage({ id: 'Documents related to this Investor' })}
                        </h2>
                        <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                          {formatMessage({ id: 'Attach files' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Add/upload documents related to this founder like Stakeholder Management Plan, etc.',
                            })}
                          />
                        </div>
                        <div className='w-100'>
                          <button
                            onClick={() => setModalStatus(true)}
                            type='button'
                            className='btn bg-primary custom-button-property text-white border border-1 mb-4 px-6 py-4 text-center w-100 w-md-auto'
                          >
                            {formatMessage({ id: 'Import Files' })}
                          </button>
                        </div>
                      </div>

                      <div className='mb-4'>
                        {files.length > 0 && (
                          <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                            {formatMessage({ id: 'Uploaded Files' })}{' '}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Manage all the uploaded documents here.',
                              })}
                            />
                          </div>
                        )}
                        <FileUpload
                          fileSize={parseInt(process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE!)}
                          maxFileNumber={10}
                          allowType={allowedFileTypes}
                          metaData={{ module: 'document', isProtected: false }}
                          modalStatus={modalStatus}
                          handleClose={() => {
                            TagManager.dataLayer({
                              dataLayer: {
                                event: GTMEvent.ShareholderCreationDocumentsUploadFailed,
                                action: 'normal',
                                metadata: {
                                  company_id: companyId,
                                  user_id: currentUser?.userId,
                                  email: currentUser?.email,
                                },
                              },
                            })
                            setModalStatus(false)
                          }}
                          handleSuccess={(id: number, name: string) => {
                            setIsNotInitiaized(false)

                            setFiles((prevFiles: any) => [...prevFiles, { id, name }])

                            if (formikRef.current) {
                              const currentFileIds = Array.isArray(formikRef.current.values.fileIds)
                                ? formikRef.current.values.fileIds
                                : []

                              fileRef.current.push(id) // Store only the current ID
                              const uniqueFileIds = Array.from(
                                new Set([...currentFileIds, ...fileRef.current])
                              )
                              formikRef.current.setFieldValue('fileIds', uniqueFileIds)
                              TagManager.dataLayer({
                                dataLayer: {
                                  event: GTMEvent.ShareholderCreationDocumentsUploadSuccessful,
                                  action: 'normal',
                                  metadata: {
                                    company_id: companyId,
                                    user_id: currentUser?.userId,
                                    email: currentUser?.email,
                                    document_name: name,
                                    document_id: id,
                                  },
                                },
                              })
                            }
                          }}
                          resourceType='all'
                        />

                        {shareholderDetailsLoading ? (
                          <>
                            <div className='w-50'>
                              <Skeleton
                                width={'100%'}
                                height={48}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                            <div className='w-50'>
                              <Skeleton
                                width={'100%'}
                                height={48}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                          </>
                        ) : (
                          <div className='w-100'>
                            <ul className='p-0 m-0'>
                              {files?.map((file: any) => (
                                <li
                                  key={file.id}
                                  className='d-flex align-items-center gap-2 text-decoration-none mb-3 w-100 border border-1 p-2'
                                >
                                  <div className='d-flex justify-content-between align-items-center w-100'>
                                    <div className='w-100 d-flex align-items-center gap-2'>
                                      <img
                                        src={getFileType(file.name)}
                                        alt={file.name}
                                        style={{ height: '30px', width: '30px' }}
                                      />

                                      <p className='p-0 m-0 max-file-width'>
                                        {file.name.split('/').pop()}
                                      </p>
                                    </div>

                                    <button
                                      type='button'
                                      className='btn btn-secondry p-0 m-0  d-flex align-items-start'
                                      onClick={() => {
                                        setDeleteFileId(file.id)
                                        setDeleteShowModal(true)
                                      }}
                                    >
                                      <img src={deleteicon} alt='Delete' />
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        <div className='d-md-flex justify-content-end gap-2 mt-10'>
                          <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4'>
                            <button
                              className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1'
                              onClick={() => {
                                setSidebar(sidebar - 1)
                                if (formikRef.current) {
                                  formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                }
                              }}
                            >
                              {formatMessage({ id: 'Back' })}
                            </button>
                            <button
                              type='button'
                              onClick={formik.handleSubmit}
                              disabled={!formik.isValid || isLoading}
                              className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                            >
                              {!isLoading && (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Submit' })}
                                </span>
                              )}
                              {isLoading && (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Please wait...' })}
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
      <DeleteFileConfirmationModal
        setDeleteShowModal={setClearFormDataShowModal}
        showDeleteModal={clearFormDataShowModal}
        onDeleteSubmit={handleClearFormData}
        deleteLoading={clearFormDataLoading}
        header='Clear Form Data In Steps'
        paragraph='Are you sure you want to clear all the form data across the steps (Personal Details, Address, Other Details)?'
      />
    </>
  )
}
